import fundingCalculatorUi from '../funding-calculator-ui';
import $ from 'jquery';
import searchSlider from './sopimus-search-slider';
import searchDropDownList from './sopimus-search-dropdownlist';
import './dropdownlist';
import initModal from './modal';

const sopimusDiv = document.querySelector('.sopimus');

$(document).ready(async () => {
  if (sopimusDiv) {
    // Modal trigger
    const modal = document.getElementById('modal');
    const slider = document.querySelectorAll('.search-slider');
    const dropdownlist = document.querySelectorAll('.dropdown');
    if (modal) {
      console.log('Huuray Autosalpasopimus');
      //Init funding calculators
      $('.funding-calculator-container').each((i, item) => {
        const fcu = new fundingCalculatorUi();
        fcu.init(item);
      });
      window.searchOptions = {
        min: false,
        max: false,
        mileage: false,
        months: false,
        make: false
      };
      if (slider.length > 0) {
        searchSlider.init();
      }
      if (dropdownlist.length > 0) {
        searchDropDownList.init();
      }
    }
  }
  if (document.getElementById('modal')) initModal();
  const search = window.location.search;
  const slug = {};
  if (search)
    search
      .substring(1)
      .split('&')
      .forEach(pair => {
        const pairValue = pair.split('=');
        slug[pairValue[0]] = pairValue[1];
      });
  if (search) console.log(slug);
  const lease = document.querySelector(`input[name='{{activeMonthlyCategory}}'][value='${slug.leasingOptions}']`);
  if (lease) lease.click();

  const mileage = document.querySelector(`input[name='{{activeMileageOptions}}'][value='${slug.mileageOptions}']`);
  if (mileage) mileage.click();

  if (slug.deposit) {
    const deposit = document.querySelector('.sopimus-deposit');
    deposit.value = slug.deposit;
  }
  $('.nav-burger').click(function() {
    $(this).toggleClass('open');
    $('.nav-items').toggleClass('open');
  });
});
